export const AiProcessFieldEnum = {
    NAME: 'name',
    DESCRIPTION: 'description',
    KEYWORDS: 'keywords'
} as const;

export type AiProcessField = typeof AiProcessFieldEnum[keyof typeof AiProcessFieldEnum];

const LABEL_KEYS: Record<AiProcessField, string> = {
    [AiProcessFieldEnum.NAME]: 'aiGeneration.fields.name',
    [AiProcessFieldEnum.DESCRIPTION]: 'aiGeneration.fields.description',
    [AiProcessFieldEnum.KEYWORDS]: 'aiGeneration.fields.seo'
};

const TASK_FIELDS: Record<AiProcessField, string> = {
    [AiProcessFieldEnum.NAME]: 'names',
    [AiProcessFieldEnum.DESCRIPTION]: 'descriptions',
    [AiProcessFieldEnum.KEYWORDS]: 'keywords'
};

export function getAiProcessFields(settings: {fields?: string[]} | null): AiProcessField[] {
    const fields = settings?.fields ?? [];

    return Object.values(AiProcessFieldEnum).filter(field => fields.includes(field));
}

export function getAiProcessFieldLabelKey(field: AiProcessField): string {
    return LABEL_KEYS[field];
}

export function getAiProcessTaskField(field: AiProcessField): string {
    return TASK_FIELDS[field];
}
